import { __awaiter, __generator } from "tslib";
import { delay } from '../index';
export var eventually = function (callback, timeout, retryDelay, errorSet) {
    if (timeout === void 0) { timeout = 3000; }
    if (retryDelay === void 0) { retryDelay = 100; }
    if (errorSet === void 0) { errorSet = new Set(); }
    return __awaiter(void 0, void 0, void 0, function () {
        var message, e_1, now, delta;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (timeout < 0) {
                        message = Array.from(errorSet).reduce(function (previousMessage, currentMessage, idx) { return previousMessage + "\n\t\t" + (idx + 1) + ". " + currentMessage; }, '');
                        throw new Error("[Eventually timeout exceeded after: timeout with error]: " + message);
                    }
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 5]);
                    return [4 /*yield*/, callback()];
                case 2:
                    _a.sent();
                    return [3 /*break*/, 5];
                case 3:
                    e_1 = _a.sent();
                    now = Date.now();
                    return [4 /*yield*/, delay(retryDelay)];
                case 4:
                    _a.sent();
                    delta = Date.now() - now;
                    errorSet.add(e_1.message);
                    return [2 /*return*/, eventually(callback, timeout - delta, retryDelay, errorSet)];
                case 5: return [2 /*return*/];
            }
        });
    });
};
//# sourceMappingURL=index.js.map